export default __webpack_public_path__ + "static/media/lb-gp.5a276f39.webp";